/* eslint-disable max-lines-per-function */
define(function (require, exports, module) {
    'use strict';

    const MicroEvent = require('mrg-microevent');
    const dataTransferReader = require('./dataTransferReader');
    const env = require('../env');
    const app = require('Cloud/Application/app');
    const { store: reduxStore } = require('reactApp/store');
    const { getAllowedExtensions } = require('reactApp/modules/upload/upload.selectors');
    const { getExtension } = require('reactApp/modules/file/utils');
    const { setNotAllowedExtensionsAction } = require('reactApp/modules/upload/upload.module');

    /**
     * @constructor
     * @extends {MicroEvent}
     * @param {HTMLElement} target
     */
    function DropArea(target) {
        MicroEvent.call(this);

        this.target = target;
        target.addEventListener('drop', this);
        target.addEventListener('dragover', this);
    }

    Object.assign(DropArea, {
        /**
         * @static
         * @type {string}
         */
        EVENT_DROP: 'drop',

        /**
         * @static
         * @returns {boolean}
         */
        isSupported: function () {
            return 'ondrop' in document.documentElement;
        },
    });

    DropArea.prototype = Object.assign(Object.create(MicroEvent.prototype), {
        constructor: DropArea,

        /**
         * @type {HTMLElement}
         */
        target: null,

        _disabled: false,

        /**
         * @private
         * @param {DragEvent} event
         */
        _onDrop(event) {
            if (this._disabled) {
                event.preventDefault();
                return;
            }

            const data = {};
            const dataTransfer = event.dataTransfer;
            const isEdge = env.isEdge;
            const allowedExtensions = getAllowedExtensions(reduxStore.getState());

            let hasNotAllowedExtensions = false;
            let entries;

            const filterAllowedFiles = (item) => {
                const name = item.name;
                const ext = (getExtension(name) || '').toLowerCase();
                const isAllowed = allowedExtensions ? allowedExtensions.includes(ext) : true;

                if (!isAllowed) {
                    hasNotAllowedExtensions = true;
                }

                return isAllowed;
            };

            if (!dataTransfer) {
                return;
            }

            if (!isEdge) {
                // @type {Array.<FileEntry|DirectoryEntry>}
                entries = dataTransferReader.getEntries(dataTransfer);
            }

            if (entries && entries.length) {
                data.entries = entries.filter(filterAllowedFiles);
            } else {
                // @type {Array.<File>}
                const files = dataTransferReader.getFiles(dataTransfer);

                if (files && files.length) {
                    data.files = files.filter(filterAllowedFiles);
                }
            }

            if (hasNotAllowedExtensions) {
                reduxStore.dispatch(setNotAllowedExtensionsAction());
            }

            if ((data.entries && data.entries.length) || (data.files && data.files.length)) {
                // TODO: если дропнуть папку в строй версии Firefox,
                // то можно получить пустой массив.
                this.emit(DropArea.EVENT_DROP, data);
            }
        },

        /**
         * @private
         * @param {DragEvent} event
         */
        handleEvent: function (event) {
            var dataTransfer = event.dataTransfer;

            if (dataTransfer) {
                var hasFileType = dataTransferReader.hasFileType(dataTransfer);

                if (hasFileType) {
                    event.preventDefault();
                    event.stopPropagation();

                    dataTransfer.dropEffect = 'copy';

                    if (event.type === 'drop') {
                        this._onDrop(event);
                    }
                }
            }
        },

        disableDropArea: function () {
            this._disabled = true;
        },

        enableDropArea: function () {
            this._disabled = false;
        },

        destroy: function () {
            var target = this.target;

            target.removeEventListener('drop', this);
            target.removeEventListener('dragover', this);

            this.target = null;
        },
    });

    module.exports = DropArea;
});
